import { AiApplicationsContract } from '@terra/shared-contracts-ai-applications';
import {
  getTerraConfigValue,
  createTerraOrpcClient,
} from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const aiApplicationsClient = createTerraOrpcClient({
  contract: AiApplicationsContract,
  credentials: 'include',
  resolveBaseUrl: () =>
    `${getTerraConfigValue('NEXT_PUBLIC_API_GATEWAY_ADDRESS')}/${SERVICE_NAME}`,
});
